import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { formatNumber } from '../../../utils/helpers';

const PriceFieldsGroup = ({ isHiddenHeader }) => {
  const { t } = useTranslation();

  return (
    <div
      className="search-form__fields search-form__fields--price f-input-group"
      data-cy="price-group"
    >
      <div
        className="search-form__fields_label f-input__title"
        data-cy="fields-label"
      >
        {t('search.form.price')}
      </div>
      <div className="search-form__fields_group f-input f-input--text-fields">
        <Field
          name="price_from"
          component="input"
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete="off"
          placeholder={t('search.form.from')}
          className="f-input__text-field"
          id="search-form-price-from"
          parse={formatNumber}
          disabled={!isHiddenHeader}
        />
        <Field
          name="price_to"
          component="input"
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete="off"
          placeholder={t('search.form.to')}
          className="f-input__text-field"
          id="search-form-price-to"
          parse={formatNumber}
          disabled={!isHiddenHeader}
        />
      </div>
    </div>
  );
};

PriceFieldsGroup.propTypes = {
  isHiddenHeader: PropTypes.bool
};

export default PriceFieldsGroup;
